import { CUSTOM_FIELD_TYPE } from '@/constants/customFields'
import {
  CUSTOM_FIELD_CELL_WIDTH,
  CUSTOM_FIELD_DATE_CELL_WIDTH,
  CUSTOM_FIELD_TEXT_CELL_WIDTH
} from '@/constants/initiative'

/**
 * This returns the width to be given to a custom field cell in initiatives table
 * @param cf
 * @returns {number}
 */
export default cf => {
  switch (cf.type) {
    case CUSTOM_FIELD_TYPE.TEXT:
      return CUSTOM_FIELD_TEXT_CELL_WIDTH
    case CUSTOM_FIELD_TYPE.DATE:
      return CUSTOM_FIELD_DATE_CELL_WIDTH
    default:
      return CUSTOM_FIELD_CELL_WIDTH
  }
}
